import type { ReactNode } from "react";
import { Button } from "./Button";
import { cn } from "../lib/cn";

export interface PaginationProps {
  label: string;
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  summary?: ReactNode;
  className?: string;
}

/** Page navigation only; filtering and slicing remain owned by the caller. */
export function Pagination({
  label,
  page,
  pageCount,
  onPageChange,
  summary,
  className,
}: PaginationProps) {
  if (pageCount <= 1) return null;
  return (
    <nav
      aria-label={label}
      className={cn(
        "flex flex-wrap items-center justify-end gap-x-3 gap-y-2 text-xs text-secondary",
        className,
      )}
    >
      {summary != null ? (
        <span className="mr-auto tabular-nums" role="status">
          {summary}
        </span>
      ) : null}
      <Button variant="ghost" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        Previous
      </Button>
      <span className="tabular-nums" aria-label={`Page ${page} of ${pageCount}`}>
        {page} / {pageCount}
      </span>
      <Button
        variant="ghost"
        size="sm"
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </Button>
    </nav>
  );
}
